export default "__VITE_ASSET__BPTMHtKx__"